// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__bZ4vq","rootCenter":"LoadMoreObserver_rootCenter__2zZBs","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3cc_S"};